import { REACT_APP_API_PREFIX } from "config/env";
import { DELETE, GET, POST, PUT } from "constants/methods";

const service = "cpfm";
const careerQuizTags = `${REACT_APP_API_PREFIX}/${service}/careerQuizTags`;

export function getCareerQuizTags(filters) {
  const url = `${careerQuizTags}${
    filters ? `?filters=${JSON.stringify(filters)}` : ""
  }`;
  return {
    method: GET,
    url,
  };
}

export function getCareerQuizTagById(id) {
  const url = `${careerQuizTags}/${id}/full`;
  return {
    method: GET,
    url,
  };
}

export function updateCareerQuizTag(id, body) {
  const url = `${careerQuizTags}/${id}`;
  return {
    method: PUT,
    url,
    body,
  };
}

export function deleteCareerQuizTag(id) {
  const url = `${careerQuizTags}/${id}`;
  return {
    method: DELETE,
    url,
  };
}

export function createCareerQuizTag(body) {
  const url = `${careerQuizTags}`;
  return {
    method: POST,
    url,
    body,
  };
}
